function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import "../cdn.scss";
export const Button = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    type = "default",
    active = false,
    submit = false,
    reset = false,
    disabled = false,
    spinner = false,
    spinnerPosition = "prepend",
    onClick = () => null,
    href = "",
    target = "",
    icon,
    children,
    className = ""
  } = _ref;
  const iconPosition = ["fa-chevron-right", "fa-arrow-up-right-from-square"].includes(icon) ? "right" : "left";
  const Tag = href && !disabled ? "a" : "button";
  const extraParams = {};
  if (!!href && !disabled) {
    extraParams.href = href;
    if (!!target) {
      extraParams.target = target;
    }
  } else if (submit === true) {
    extraParams.type = "submit";
  } else if (submit === false) {
    extraParams.type = "button";
  } else if (reset === true) {
    extraParams.type = "reset";
  }
  const Spinner = () => /*#__PURE__*/React.createElement("span", {
    className: "spinner spinner-sm mr-3"
  });
  return /*#__PURE__*/React.createElement(Tag, _extends({}, extraParams, {
    className: ["btn", ["primary", "secondary", "featured", "chip"].includes(type) && "btn-".concat(type), active && "is-active", ...className.split(" ")].filter(v => !!v).join(" "),
    ref: ref,
    onClick: onClick,
    disabled: disabled
  }), spinner && spinnerPosition === "prepend" && /*#__PURE__*/React.createElement(Spinner, null), iconPosition === "left" && icon && /*#__PURE__*/React.createElement("i", {
    className: "fa-regular ".concat(icon)
  }), children, iconPosition === "right" && icon && /*#__PURE__*/React.createElement("i", {
    className: "fa-regular ".concat(icon)
  }), spinner && spinnerPosition === "append" && /*#__PURE__*/React.createElement(Spinner, null));
});